import {
    Button,
    Card,
    Drawer,
    Form,
    Input,
    Modal,
    notification,
    Select,
    Skeleton,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { encrypt, formatDate, getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import KasaDevices from "./AssignDevice";

const { Option } = Select;

function HotelWidgets() {
    const userRole = getUserRole();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const userRoleId = localStorage.getItem("userRoleId");
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [buttonStatus, setButtonStatus] = useState(false);
    const [assignDrawerVisibility, setAssignDrawerVisibility] = useState(false);
    const [searchKey, setSearchKey] = useState("");
    const [formData, setFormData] = useState({
        staff_id,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        search_by: searchKey,
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [hotelData, setHotelData] = useState([]);
    const [visible, setVisible] = useState(false);

    const restartServices = [
        {
            key: "3",
            name: "Set Position",
        },
        {
            key: "4",
            name: "Get key Status",
        },
        {
            key: "5",
            name: "Retain Request",
        },
        {
            key: "3",
            name: "Start Dispense Notify",
        },
    ];

    const column = [
        {
            title: "Hotel Name",
            key: "hotel_name",
            render: (text, record) => {
                return (
                    <span
                        onClick={() => {
                            navigate(
                                `/hotel-dashboard?id=${encrypt(
                                    record.hotel_id.toString(),
                                ).replace("+", "plus")}`,
                            );
                        }}
                        style={{ color: "#1890ff", cursor: "pointer" }}
                    >{`${record.hotel_name} - ${record.city}`}</span>
                );
            },
            sorter: () => {},
            width: "10%",
        },
        {
            title: "Kiosk Name",
            dataIndex: "kiosk_name",
            key: "kiosk_name",
            sorter: () => {},
            width: "10%",
        },
        {
            title: "Agent",
            render: (text, record) => (
                <span>
                    {`${record.staff_first_name} ${record.staff_last_name}`}
                </span>
            ),
        },
        {
            title: "Call Status",
            render: (text, record) => (
                <p
                    className={
                        record.has_ongoing_call ? "live-call" : "no-call"
                    }
                    style={{ color: record.has_ongoing_call ? "green" : "red" }}
                >
                    LIVE CALL
                </p>
            ),
        },
        {
            title: "Smart Plug ",
            render: (_, record) => {
                const device = record?.devices?.find((d) => d.type == 1);
                const deviceState =
                    device && device?.relay_state == 1 ? "On" : "Off";
                let backgroundColor = !device
                    ? "gray"
                    : device?.relay_state == 1
                    ? "green"
                    : "red";

                return (
                    <>
                        <Button
                            size="small"
                            onClick={() =>
                                toggleKioskStatus(
                                    device?.device_id,
                                    record.hotel_id,
                                    record.kiosk_id,
                                    1,
                                    device?.relay_state == 1 ? 2 : 1,
                                )
                            }
                            type="default"
                            disabled={!device}
                            style={{
                                backgroundColor: backgroundColor,
                                color: "white",
                            }}
                        >
                            {deviceState}
                        </Button>
                    </>
                );
            },
        },
        {
            title: "Smart CC",
            render: (_, record) => {
                const device = record?.devices?.find((d) => d.type == 2);
                let deviceState =
                    device && device?.relay_state == 1 ? "On" : "Off";
                let backgroundColor = !device
                    ? "gray"
                    : device?.relay_state == 1
                    ? "green"
                    : "red";
                return (
                    <>
                        <Button
                            size="small"
                            type="default"
                            onClick={() =>
                                toggleKioskStatus(
                                    device?.device_id,
                                    record.hotel_id,
                                    record.kiosk_id,
                                    2,
                                    device?.relay_state == 1 ? 2 : 1,
                                )
                            }
                            style={{
                                backgroundColor: backgroundColor,
                                color: "white",
                            }}
                            disabled={!device}
                        >
                            {deviceState}
                        </Button>
                    </>
                );
            },
        },
        {
            title: "HIM",
            render: (text, record) => {
                return (
                    <Button
                        datatype={1}
                        hotel_id={record.hotel_id}
                        kiosk_id={record.kiosk_id}
                        onClick={requestRestart}
                        disabled={
                            getUserRole() === "Customer" ||
                            getUserRole() === "Customer Success"
                                ? true
                                : false
                        }
                    >
                        HIM
                    </Button>
                );
            },
        },
        {
            title: "ASM",
            render: (text, record) => (
                <Button
                    datatype={2}
                    hotel_id={record.hotel_id}
                    kiosk_id={record.kiosk_id}
                    onClick={requestRestart}
                    disabled={
                        getUserRole() === "Customer" ||
                        getUserRole() === "Customer Success"
                            ? true
                            : false
                    }
                >
                    ASM
                </Button>
            ),
        },
        {
            title: "Actions",
            render: (text, record) => {
                return (
                    <>
                        <Form
                            onFinish={handleServiceRequestSubmit}
                            initialValues={{
                                hotel_id: record.hotel_id,
                                kiosk_id: record.kiosk_id,
                            }}
                        >
                            <Form.Item
                                name="type"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Select Service!",
                                    },
                                ]}
                                valuePropName="defaultValue"
                            >
                                <Select
                                    id="type"
                                    style={{ width: 200 }}
                                    onChange={handleTypeSelection}
                                >
                                    {restartServices.map((service) => (
                                        <Option
                                            key={`${service.key}#${service.name}`}
                                            value={`${service.key}#${service.name}`}
                                            hotel_id={record.hotel_id}
                                            kiosk_id={record.kiosk_id}
                                        >
                                            {service.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="hotel_id"
                                style={{ display: "none" }}
                            >
                                <Input id="hotel_id" />
                            </Form.Item>

                            <Form.Item
                                name="action_type"
                                style={{ display: "none" }}
                            >
                                <Input id="action_type"></Input>
                            </Form.Item>

                            <Form.Item
                                name="kiosk_id"
                                style={{ display: "none" }}
                            >
                                <Input id="kiosk_id" />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    disabled={
                                        getUserRole() === "Customer" ||
                                        getUserRole() === "Customer Success"
                                            ? true
                                            : false
                                    }
                                >
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>
                    </>
                );
            },
            width: "15%",
        },
        {
            title: "Get Restart History",
            render: (text, record) => (
                <Button
                    hotel_id={record.hotel_id}
                    kiosk_id={record.kiosk_id}
                    onClick={getRestartHistory}
                >
                    Get Restart History
                </Button>
            ),
            width: "15%",
        },
        {
            title: "Support",
            render: (text, record) => {
                const color = record.has_sp_open_ticket ? "red" : "green";
                return (
                    <div
                        style={{
                            backgroundColor: color,
                            width: "3vw",
                            minWidth: 55,
                            height: "3vh",
                            borderRadius: "15px",
                        }}
                        onClick={() => {
                            if (color === "red") {
                                navigate("/support-details-table", {
                                    state: {
                                        id: record.hotel_id,
                                        filter: false,
                                    },
                                });
                            }
                        }}
                    ></div>
                );
            },
        },
    ];

    function handleTypeSelection(e) {
        if (e === "3#Set Position" || e === "3#Start Dispense Notify") {
            const action_type = e === "3#Set Position" ? 1 : 2;
            form.setFieldsValue({ action_type });
        } else {
            form.setFieldsValue({ action_type: "" });
        }
    }

    function handleServiceRequestSubmit(formData) {
        const [type] = formData.type.split("#");
        if (
            formData.type === "3#Set Position" ||
            formData.type === "3#Start Dispense Notify"
        ) {
            formData.action_type = formData.type === "3#Set Position" ? 1 : 2;
        }
        formData.type = type;
        requestRestart(formData, 1);
    }

    function getRestartHistory(e) {
        navigate("/restart-history", {
            state: {
                hotel_id: e.currentTarget.getAttribute("hotel_id"),
                kiosk_id: e.currentTarget.getAttribute("kiosk_id"),
            },
        });
    }

    function requestRestart(e, fromDropDown) {
        let details = e;
        if (!fromDropDown) {
            details = {
                type: e.currentTarget.getAttribute("datatype"),
                hotel_id: e.currentTarget.getAttribute("hotel_id"),
                kiosk_id: e.currentTarget.getAttribute("kiosk_id"),
            };
        }
        form.setFieldsValue(details);
        setVisible(true);
    }

    function handleSearchInputSubmit() {
        const updatedFormData = { ...formData, search_by: searchKey };
        setFormData(updatedFormData);
    }

    function handleSearchInputChange(event) {
        setSearchKey(event.target.value);
    }

    function toggleKioskStatus(device_id, hotel_id, kiosk_id, is_for, type) {
        const details = {};
        details.device_id = device_id;
        details.hotel_id = hotel_id;
        details.kiosk_id = kiosk_id;
        details.is_for = is_for;
        details.type = type;
        form.setFieldsValue(details);
        setVisible(true);
    }

    function closeModel() {
        setVisible(false);
        form.resetFields();
    }

    const {
        status: widgetStatus,
        data: widgetRes,
        refetch: getHotelWidgets,
    } = useQuery(
        "hotel-widgets",
        async () => {
            return await HTTP("/hotels/getHotelWidgets", { ...formData });
        },
        { enabled: false },
    );

    useEffect(() => {
        if (widgetStatus === "success") {
            const { data: hotelData, total } = widgetRes;
            setTotalRecords(total);
            setHotelData(hotelData);
        }
    }, [widgetStatus, widgetRes]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        const updatedFormData = {
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        };
        setFormData(updatedFormData);
    }, [selectedDates]);

    useEffect(() => {
        getHotelWidgets();
    }, []);

    useEffect(() => {
        getHotelWidgets();
    }, [formData]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }

        const newFormData = {
            ...formData,
            ...others,
        };

        setFormData(newFormData);
    }

    async function handleSubmit(formData) {
        formData.password = encrypt(formData.password);
        let api_success, api_message;
        if (formData.is_for === undefined) {
            const [type] = formData.type.split("#");
            formData.type = type;
            setButtonStatus(true);
            if (type != 3) delete formData.action_type;
            const { success, message } = await HTTP(
                "/hotels/serviceRestartRequest",
                {
                    staff_id,
                    ...formData,
                },
            );
            api_success = success;
            api_message = message;
        } else {
            const { success, message } = await HTTP(
                "/hotels/smartDeviceRestartRequest",
                {
                    staff_id,
                    ...formData,
                },
            );
            getHotelWidgets();
            api_success = success;
            api_message = message;
        }
        let notification_type = "info";
        if (api_success === 0) {
            notification_type = "error";
        }
        notification[notification_type]({
            message: api_message,
        });
        setButtonStatus(false);
        closeModel();
    }

    function toggleAssignDrawer() {
        setAssignDrawerVisibility(!assignDrawerVisibility);
        if (assignDrawerVisibility) {
            getHotelWidgets();
        }
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        (userRole === "Super Admin" ||
                            userRole === "Admin" ||
                            userRole === "Support") && (
                            <Button
                                type="primary"
                                style={{ marginRight: "5px" }}
                                onClick={toggleAssignDrawer}
                            >
                                Kasa Devices
                            </Button>
                        )
                    }
                />
                <Card
                    className="box-shadow margin-10"
                    title={
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Input
                                placeholder="Search By"
                                style={{ width: "20%" }}
                                className="margin-right-10"
                                value={searchKey}
                                onChange={handleSearchInputChange}
                            />
                            <Button
                                type="primary"
                                onClick={handleSearchInputSubmit}
                            >
                                Search
                            </Button>
                        </div>
                    }
                >
                    {widgetStatus !== "loading" && widgetStatus !== "idle" ? (
                        <CustomTable
                            columns={column}
                            tableData={hotelData}
                            noOfrecords={totalRecords}
                            handleTableChange={handleTableChange}
                            className="hotelLiveDashboard"
                            rowKey="kiosk_id"
                            // isScroll
                        />
                    ) : (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    )}
                </Card>
            </Card>
            <Modal
                title={"Authentication"}
                open={visible}
                onCancel={closeModel}
                destroyOnClose={true}
                footer=""
            >
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    onFinish={handleSubmit}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Username"
                        name="email"
                        rules={[
                            {
                                required: true,
                                message: "Please input user name!",
                            },
                        ]}
                    >
                        <Input
                            placeholder="user"
                            id="email"
                            className="upcoming-form-inputs"
                        ></Input>
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please enter password!",
                            },
                        ]}
                    >
                        <Input
                            type="password"
                            placeholder="Password"
                            id="password"
                            className="upcoming-form-inputs"
                        ></Input>
                    </Form.Item>

                    <Form.Item name="action_type" className="hidden">
                        <Input
                            id="action_type"
                            className="upcoming-form-inputs"
                            disabled
                        ></Input>
                    </Form.Item>
                    <Form.Item name="type" className="hidden">
                        <Input
                            id="type"
                            className="upcoming-form-inputs"
                            disabled
                        ></Input>
                    </Form.Item>
                    <Form.Item name="hotel_id" className="hidden">
                        <Input
                            id="hotel_id"
                            className="upcoming-form-inputs"
                            disabled
                        ></Input>
                    </Form.Item>
                    <Form.Item name="kiosk_id" className="hidden">
                        <Input
                            id="kiosk_id"
                            className="upcoming-form-inputs"
                            disabled
                        ></Input>
                    </Form.Item>
                    <Form.Item name="device_id" className="hidden">
                        <Input
                            id="device_id"
                            className="upcoming-form-inputs"
                            disabled
                        ></Input>
                    </Form.Item>
                    <Form.Item name="is_for" className="hidden">
                        <Input
                            id="is_for"
                            className="upcoming-form-inputs"
                            disabled
                        ></Input>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={buttonStatus}
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            <Drawer
                title={"Kasa Devices"}
                destroyOnClose
                open={assignDrawerVisibility}
                onClose={toggleAssignDrawer}
            >
                <div
                    style={{
                        width: "70vw",
                        margin: "15px",
                    }}
                >
                    <KasaDevices />
                </div>
            </Drawer>
        </>
    );
}

export { HotelWidgets };
